<button type="button"
        class="btn {{cssClasses}}"
        [tabIndex]="tabindex"
        [attr.aria-label]="ariaLabel"
        [disabled]="disabled"
        [ngClass]="{'disabled-btn': disabled, 'active': active}"
        (click)='this.buttonClicked.emit()'
        #buttonElement>

    <span *ngIf="overIconText" class="text-over-icon">{{overIconText}}</span>

    <mat-icon *ngIf="icon || iconAdditionalClass" class="material-icons-round btn-icon
                icon-color__{{iconColor}} icon-size__{{iconSize}} {{iconAdditionalClass}}">
        {{icon}}
    </mat-icon>

    <mat-icon *ngIf="iconState=='playState'" class="material-icons-round btn-icon icon-color__{{iconColor}} icon-size__{{iconSize}}">
        {{basicMode ? basicPlayIcon : playIcon}}
    </mat-icon>
    <mat-icon *ngIf="iconState=='pauseState'" class="material-icons-round btn-icon icon-color__{{iconColor}} icon-size__{{iconSize}}">
        {{pauseIcon}}
    </mat-icon>

    <mat-icon *ngIf="customIcon" class="btn-icon custom-icon"
              svgIcon='{{customIcon}}'></mat-icon>

    <span class="btn-label btn-label-color__{{labelColor}}"
          [ngClass]="{'hide-label-on-mobile': hideLabelMobileOnly}" [ngClass]="{'hide-label': hideLabel}">
        <ng-content></ng-content>
    </span>

    <span *ngIf="additionalText" class="btn-additional-text">
        {{additionalText}}
    </span>
</button>
